import { useAuthStore } from '../store/authStore';
import { buildPortalAccess, firstPortalPath } from '../config/permissions.config';

/** Resolved portal RBAC flags for the logged-in user (dynamic + legacy fallback). */
export function usePortalAccess() {
  const auth = useAuthStore();
  const access = buildPortalAccess(auth);
  return { ...access, firstPath: firstPortalPath(access) };
}
